// import React, { useState, useRef, useCallback, memo, useEffect } from 'react'
// import axios from 'axios'

// import { Url } from '../url/url';

// import EmailBuilder from './Emailbuilder'

// // ─────────────────────────────────────────────────────────────────
// // UTILS
// // ─────────────────────────────────────────────────────────────────
// let _id = 0
// const uid = () => { _id += 1; return `b${_id}` }
// const clone = x => JSON.parse(JSON.stringify(x))

// // ─────────────────────────────────────────────────────────────────
// // MAIN BULKMAILING COMPONENT
// // ─────────────────────────────────────────────────────────────────
// const BulkMailing = () => {
//   const [tab, setTab]                       = useState('csv')
//   const [csvFiles, setCsvFiles]             = useState([])
//   const [csvLoading, setCsvLoading]         = useState(false)
//   const [csvUploading, setCsvUploading]     = useState(false)
//   const [selectedCSV, setSelectedCSV]       = useState(null)
//   const [previewLoading, setPreviewLoading] = useState(false)
//   const [subject, setSubject]               = useState('')
//   const [body, setBody]                     = useState('')
//   const [showBuilder, setShowBuilder]       = useState(false)
//   const [attachments, setAttachments]       = useState([])
//   const [attachPreviews, setAttachPreviews] = useState([])
//   const [sending, setSending]               = useState(false)
//   const [progress, setProgress]             = useState(0)
//   const [sent, setSent]                     = useState(0)
//   const [failed, setFailed]                 = useState(0)
//   const [done, setDone]                     = useState(false)
//   const [errors, setErrors]                 = useState([])

//   // Campaign history states
//   const [campaigns, setCampaigns]               = useState([])
//   const [campaignLoading, setCampaignLoading]   = useState(false)
//   const [selectedCampaign, setSelectedCampaign] = useState(null)
//   const [campaignDetail, setCampaignDetail]     = useState(null)
//   const [detailLoading, setDetailLoading]       = useState(false)
//   const [campaignFilter, setCampaignFilter]     = useState('all') // all | sent | failed

//   const csvRef = useRef()
//   const attRef = useRef()

//   useEffect(() => { fetchCSVList(); fetchCampaigns() }, [])

//   const fetchCSVList = async () => {
//     setCsvLoading(true)
//     try {
//       const r = await axios.get(`${Url}/api/bulkmail/csv/list`)
//       setCsvFiles(r.data.files || [])
//     } catch(e){ console.error(e) }
//     setCsvLoading(false)
//   }

//   const fetchCampaigns = async () => {
//     setCampaignLoading(true)
//     try {
//       const r = await axios.get(`${Url}/api/bulkmail/campaigns?limit=50`)
//       setCampaigns(r.data.campaigns || [])
//     } catch(e){ console.error(e) }
//     setCampaignLoading(false)
//   }

//   const fetchCampaignDetail = async (id) => {
//     setDetailLoading(true)
//     try {
//       const r = await axios.get(`${Url}/api/bulkmail/campaigns/${id}`)
//       setCampaignDetail(r.data.campaign)
//     } catch(e){ console.error(e) }
//     setDetailLoading(false)
//   }

//   const deleteCampaign = async (id, e) => {
//     e.stopPropagation()
//     if (!window.confirm('are you sure to delte this campaign record?')) return
//     try {
//       await axios.delete(`${Url}/api/bulkmail/campaigns/${id}`)
//       setCampaigns(p => p.filter(c => c._id !== id))
//       if (selectedCampaign === id) { setSelectedCampaign(null); setCampaignDetail(null) }
//     } catch(e){ alert('Delete failed') }
//   }

//   const handleCSVUpload = async e => {
//     const f = e.target.files[0]; if (!f) return
//     setCsvUploading(true)
//     const fd = new FormData(); fd.append('csv', f)
//     try { await axios.post(`${Url}/api/bulkmail/csv/upload`, fd); await fetchCSVList() }
//     catch(e){ alert(e.response?.data?.message||'Upload failed') }
//     setCsvUploading(false); csvRef.current.value = ''
//   }

//   const handleSelectCSV = async f => {
//     if (selectedCSV?.key===f.key) { setSelectedCSV(null); return }
//     setPreviewLoading(true)
//     try {
//       const r = await axios.get(`${Url}/api/bulkmail/csv/preview`, { params:{ key:f.key } })
//       setSelectedCSV({ key:f.key, originalName:f.originalName, total:r.data.total, preview:r.data.preview })
//     } catch(e){ alert(e.response?.data?.message||'Preview failed') }
//     setPreviewLoading(false)
//   }

//   const handleDeleteCSV = async (key, name) => {
//     if (!window.confirm(`"${name}" are you sure to delete?`)) return
//     try { await axios.delete(`${Url}/api/bulkmail/csv/delete`,{data:{key}}); if(selectedCSV?.key===key) setSelectedCSV(null); await fetchCSVList() }
//     catch(e){ alert(e.response?.data?.message||'Delete failed') }
//   }

//   const handleAttachments = e => {
//     const files = Array.from(e.target.files).slice(0, 5-attachments.length)
//     setAttachments(p=>[...p,...files])
//     files.forEach(f=>{
//       if (f.type.startsWith('image/')) {
//         const r=new FileReader()
//         r.onload=ev=>setAttachPreviews(p=>[...p,{type:'image',url:ev.target.result,name:f.name}])
//         r.readAsDataURL(f)
//       } else setAttachPreviews(p=>[...p,{type:'file',name:f.name}])
//     })
//   }

//   const removeAtt = i => {
//     setAttachments(p=>p.filter((_,idx)=>idx!==i))
//     setAttachPreviews(p=>p.filter((_,idx)=>idx!==i))
//   }

//   const handleSend = async () => {
//     if (!subject.trim()) { alert('Subject required!'); return }
//     if (!body.trim())    { alert('Email body required!'); return }
//     if (!selectedCSV)    { alert('Pehle CSV select karo!'); return }
//     const jobId = `job_${Date.now()}`
//     setSending(true); setDone(false); setSent(0); setFailed(0); setErrors([]); setProgress(0)
//     const es = new EventSource(`${Url}/api/bulkmail/progress/${jobId}`)
//     es.onmessage = e => {
//       const d = JSON.parse(e.data)
//       if (d.type==='progress')       { setProgress(Math.round((d.current/d.total)*100)); setSent(d.sent||0); setFailed(d.failed||0) }
//       else if (d.type==='complete')  { setProgress(100); setSent(d.sent); setFailed(d.failed); setErrors(d.errors||[]); setSending(false); setDone(true); es.close() }
//       else if (d.type==='error')     { alert(d.message); setSending(false); es.close() }
//     }
//     es.onerror = () => { setSending(false); es.close() }
//     const fd = new FormData()
//     fd.append('subject',subject); fd.append('htmlBody',body); fd.append('jobId',jobId)
//     fd.append('csvKey',selectedCSV.key); fd.append('delayMs','300')
//     attachments.forEach(f=>fd.append('attachments',f))
//     try { await axios.post(`${Url}/api/bulkmail/send`, fd) }
//     catch(e){ alert(e.response?.data?.message||'Send failed'); setSending(false); es.close() }
//   }

//   const handleTestSMTP = async () => {
//     try { const r = await axios.post(`${Url}/api/bulkmail/test`); alert(r.data.message) }
//     catch(e){ alert(e.response?.data?.message||'SMTP failed') }
//   }

//   // ── Attachment mini-panel ──
//   const AttachmentPanel = () => (
//     <div>
//       <div
//         role="button"
//         tabIndex={0}
//         onClick={()=>attRef.current.click()}
//         onKeyDown={e=>{ if(e.key==='Enter'||e.key===' ') attRef.current.click() }}
//         style={{ border:'2px dashed #d1d5db', borderRadius:10, padding:'1rem', textAlign:'center', cursor:'pointer', background:'#f9fafb', marginBottom:10 }}>
//         <div style={{ fontSize:13, fontWeight:600 }}>📎 {attachments.length>0 ? `${attachments.length} file${attachments.length>1?'s':''} attached — click to add more` : 'Click to attach (optional)'}</div>
//         <div style={{ fontSize:11, color:'#9ca3af', marginTop:2 }}>Images, PDFs, docs — max 5 files, 10MB each</div>
//         <input ref={attRef} type="file" multiple accept="image/*,.pdf,.doc,.docx" style={{ display:'none' }} onChange={handleAttachments} />
//       </div>
//       {attachPreviews.length>0 && (
//         <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
//           {attachPreviews.map((p,i)=>(
//             <div key={i} style={{ position:'relative', width:70, height:70 }}>
//               {p.type==='image'
//                 ? <img src={p.url} alt="" style={{ width:70, height:70, objectFit:'cover', borderRadius:7, border:'1px solid #e5e7eb' }} />
//                 : <div style={{ width:70, height:70, borderRadius:7, border:'1px solid #e5e7eb', background:'#f3f4f6', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:3 }}>
//                     <span style={{ fontSize:20 }}>📄</span>
//                     <span style={{ fontSize:9, color:'#6b7280', textAlign:'center', padding:'0 3px', wordBreak:'break-all' }}>{p.name.slice(0,10)}</span>
//                   </div>
//               }
//               <button onClick={()=>removeAtt(i)}
//                 style={{ position:'absolute', top:-5, right:-5, background:'#ef4444', color:'white', border:'none', borderRadius:'50%', width:18, height:18, cursor:'pointer', fontSize:10, lineHeight:'18px', textAlign:'center', padding:0 }}>✕</button>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   )

//   return (
//     <div style={{ fontFamily:'sans-serif', maxWidth:1200, margin:'0 auto', padding:'1.5rem' }}>
//       <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.5rem' }}>
//         <h2 style={{ margin:0, fontSize:20, fontWeight:700 }}>📧 Bulk Mailing</h2>
//         <button onClick={handleTestSMTP} style={bSec}>Test SMTP</button>
//       </div>

//       {/* ── TABS ── */}
//       <div style={{ display:'flex', borderBottom:'1px solid #e5e7eb', marginBottom:'1.5rem' }}>
//         {[
//           { key:'csv',     label:'📁 CSV Files' },
//           { key:'compose', label:'→ Compose' },
//           { key:'send',    label:'→ Send' },
//           { key:'history', label:`→ Campaigns${campaigns.length ? ` (${campaigns.length})` : ''}` },
//         ].map(t=>(
//           <button key={t.key} onClick={()=>setTab(t.key)} style={{
//             padding:'10px 20px', background:'none', border:'none',
//             borderBottom:tab===t.key?'2px solid #111':'2px solid transparent',
//             fontWeight:tab===t.key?600:400, cursor:'pointer',
//             color:tab===t.key?'#111':'#6b7280', fontSize:14
//           }}>{t.label}</button>
//         ))}
//       </div>

//       {/* ══ CSV TAB ══ */}
//       {tab==='csv' && (
//         <div>
//           <div
//             role="button"
//             tabIndex={0}
//             onClick={()=>!csvUploading&&csvRef.current.click()}
//             onKeyDown={e=>{ if(e.key==='Enter'||e.key===' ') { if(!csvUploading) csvRef.current.click() } }}
//             style={{ border:'2px dashed #d1d5db', borderRadius:12, padding:'2rem', textAlign:'center', cursor:csvUploading?'wait':'pointer', background:csvUploading?'#f0fdf4':'#f9fafb', marginBottom:20 }}>
//             <div style={{ fontSize:14, fontWeight:600 }}>{csvUploading?'⏳ Uploading...':'☁️ Click to upload CSV → S3'}</div>
//             <div style={{ fontSize:12, color:'#9ca3af', marginTop:4 }}>Required: <code>email</code> | Optional: <code>name</code>, <code>company</code></div>
//             <input ref={csvRef} type="file" accept=".csv" style={{ display:'none' }} onChange={handleCSVUpload} />
//           </div>

//           <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
//             <span style={{ fontWeight:600 }}>S3 CSV Files</span>
//             <button onClick={fetchCSVList} style={bSec}>{csvLoading?'...':'↻ Refresh'}</button>
//           </div>

//           {csvLoading
//             ? <p style={{ color:'#9ca3af', textAlign:'center', padding:'2rem' }}>Loading...</p>
//             : csvFiles.length===0
//               ? <p style={{ color:'#9ca3af', textAlign:'center', padding:'2rem' }}>Koi CSV nahi</p>
//               : (
//                 <div style={{ border:'1px solid #e5e7eb', borderRadius:10, overflow:'hidden' }}>
//                   <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
//                     <thead><tr style={{ background:'#f9fafb' }}>
//                       <th style={thS}>File</th><th style={thS}>Size</th><th style={thS}>Date</th><th style={thS}>Actions</th>
//                     </tr></thead>
//                     <tbody>
//                       {csvFiles.map(f=>{
//                         const isSel=selectedCSV?.key===f.key
//                         return (
//                           <React.Fragment key={f.key}>
//                             <tr style={{ background:isSel?'#eff6ff':'white', borderTop:'1px solid #f3f4f6' }}>
//                               <td style={tdS}><b>📄 {f.originalName}</b><div style={{ fontSize:11, color:'#9ca3af', fontFamily:'monospace' }}>{f.key}</div></td>
//                               <td style={tdS}>{f.sizeKB} KB</td>
//                               <td style={tdS}>{new Date(f.lastModified).toLocaleDateString()}</td>
//                               <td style={tdS}>
//                                 <div style={{ display:'flex', gap:6 }}>
//                                   <button onClick={()=>handleSelectCSV(f)} disabled={previewLoading}
//                                     style={{ ...bSec, fontSize:12, padding:'5px 12px', background:isSel?'#eff6ff':'white', color:isSel?'#1d4ed8':'#374151', borderColor:isSel?'#93c5fd':'#d1d5db' }}>
//                                     {previewLoading&&!isSel?'...':isSel?'✓ Selected':'Select'}
//                                   </button>
//                                   <button onClick={()=>handleDeleteCSV(f.key,f.originalName)}
//                                     style={{ ...bSec, fontSize:12, padding:'5px 10px', color:'#ef4444', borderColor:'#fca5a5' }}>🗑</button>
//                                 </div>
//                               </td>
//                             </tr>
//                             {isSel&&selectedCSV?.preview&&(
//                               <tr><td colSpan={4} style={{ padding:'0 14px 14px', background:'#f0f9ff' }}>
//                                 <div style={{ fontSize:12, color:'#1d4ed8', fontWeight:600, marginBottom:6 }}>👥 {selectedCSV.total} recipients</div>
//                                 <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
//                                   <thead><tr style={{ background:'#dbeafe' }}>
//                                     <th style={{ ...thS, padding:'5px 10px' }}>Email</th>
//                                     <th style={{ ...thS, padding:'5px 10px' }}>Name</th>
//                                     <th style={{ ...thS, padding:'5px 10px' }}>Company</th>
//                                   </tr></thead>
//                                   <tbody>{selectedCSV.preview.map((r,i)=>(
//                                     <tr key={i} style={{ borderTop:'1px solid #bfdbfe' }}>
//                                       <td style={{ padding:'5px 10px', fontFamily:'monospace', color:'#1d4ed8' }}>{r.email}</td>
//                                       <td style={{ padding:'5px 10px' }}>{r.name||'—'}</td>
//                                       <td style={{ padding:'5px 10px' }}>{r.company||'—'}</td>
//                                     </tr>
//                                   ))}</tbody>
//                                 </table>
//                               </td></tr>
//                             )}
//                           </React.Fragment>
//                         )
//                       })}
//                     </tbody>
//                   </table>
//                 </div>
//               )
//           }

//           <div style={{ marginTop:16, display:'flex', justifyContent:'flex-end' }}>
//             <button onClick={()=>setTab('compose')} disabled={!selectedCSV}
//               style={{ ...bPri, opacity:!selectedCSV?0.4:1, cursor:!selectedCSV?'not-allowed':'pointer' }}>
//               Next: Compose →
//             </button>
//           </div>
//         </div>
//       )}

//       {/* ══ COMPOSE TAB ══ */}
//       {tab==='compose' && (
//         <div>
//           {selectedCSV && (
//             <div style={{ padding:'8px 14px', background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, marginBottom:16, fontSize:13, color:'#16a34a' }}>
//               ✅ {selectedCSV.originalName} — {selectedCSV.total} recipients
//             </div>
//           )}

//           <div style={{ marginBottom:16 }}>
//             <label htmlFor="email-subject" style={lS}>Subject</label>
//             <input
//               id="email-subject"
//               value={subject}
//               onChange={e=>setSubject(e.target.value)}
//               placeholder="Subject... {{name}} use kar sakte ho"
//               style={iS}
//             />
//           </div>

//           <div style={{ marginBottom:8, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
//             <span id="email-body-label" style={lS}>Message Body</span>
//             <div style={{ display:'flex', border:'1px solid #e5e7eb', borderRadius:8, overflow:'hidden' }}>
//               <button onClick={()=>setShowBuilder(false)}
//                 style={{ padding:'5px 14px', fontSize:12, border:'none', cursor:'pointer', fontWeight:!showBuilder?600:400, background:!showBuilder?'#111827':'white', color:!showBuilder?'white':'#6b7280' }}>
//                 Plain Text
//               </button>
//               <button onClick={()=>setShowBuilder(true)}
//                 style={{ padding:'5px 14px', fontSize:12, border:'none', cursor:'pointer', fontWeight:showBuilder?600:400, background:showBuilder?'#111827':'white', color:showBuilder?'white':'#6b7280' }}>
//                  Template Builder
//               </button>
//             </div>
//           </div>

//           {!showBuilder && (
//             <div style={{ marginBottom:16 }}>
//               <textarea
//                 id="email-body"
//                 aria-labelledby="email-body-label"
//                 value={body}
//                 onChange={e=>setBody(e.target.value)}
//                 placeholder="Email body... {{name}}, {{company}}, {{email}}"
//                 rows={8}
//                 style={{ ...iS, resize:'vertical' }}
//               />
//               <p style={{ fontSize:12, color:'#9ca3af', marginTop:4 }}>
//                 Personalize: <code>{'{{name}}'}</code> <code>{'{{company}}'}</code> <code>{'{{email}}'}</code>
//               </p>
//             </div>
//           )}

//           {showBuilder && (
//             <div style={{ marginBottom:16 }}>
//               <EmailBuilder onUseTemplate={html=>{ setBody(html); setShowBuilder(false) }} />
//               {body && (
//                 <div style={{ marginTop:8, padding:'7px 12px', background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, fontSize:12, color:'#16a34a' }}>
//                   ✅ Template set hai
//                 </div>
//               )}
//             </div>
//           )}

//           <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
//             <button onClick={()=>setTab('csv')} style={bSec}>← Back</button>
//             <button onClick={()=>setTab('send')}
//               disabled={!subject.trim()||!body.trim()}
//               style={{ ...bPri, opacity:(!subject.trim()||!body.trim())?0.4:1, cursor:(!subject.trim()||!body.trim())?'not-allowed':'pointer' }}>
//               Next: Send →
//             </button>
//           </div>
//         </div>
//       )}

//       {/* ══ SEND TAB ══ */}
//       {tab==='send' && (
//         <div>
//           {/* Summary cards */}
//           <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:10, marginBottom:20 }}>
//             {[
//               { label:'Recipients', val:selectedCSV?.total||0,                                                                                    color: selectedCSV ? '#16a34a' : '#ef4444' },
//               { label:'Subject',    val:subject||'—',                                                                                             color: subject ? '#374151' : '#ef4444', small:true },
//               { label:'Body',       val:body?'✓ Ready':'—',                                                                                       color: body ? '#16a34a' : '#ef4444' },
//               { label:'Attachments',val:attachments.length===0 ? 'None (optional)' : `${attachments.length} file${attachments.length>1?'s':''}`, color:'#64748b', small:true },
//             ].map(s=>(
//               <div key={s.label} style={{ background:'#f9fafb', border:'1px solid #e5e7eb', borderRadius:10, padding:'12px 14px' }}>
//                 <div style={{ fontSize:s.small?13:20, fontWeight:600, color:s.color, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{s.val}</div>
//                 <div style={{ fontSize:11, color:'#6b7280', marginTop:3 }}>{s.label}</div>
//               </div>
//             ))}
//           </div>

//           {/* Validation errors */}
//           {!selectedCSV   && <div style={{ padding:'10px 14px', background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, marginBottom:10, fontSize:13, color:'#dc2626' }}>⚠️ CSV select nahi ki — CSV tab mein jao</div>}
//           {!subject.trim()&& <div style={{ padding:'10px 14px', background:'#fffbeb', border:'1px solid #fde68a', borderRadius:8, marginBottom:10, fontSize:13, color:'#92400e' }}>⚠️ Subject empty hai</div>}
//           {!body.trim()   && <div style={{ padding:'10px 14px', background:'#fffbeb', border:'1px solid #fde68a', borderRadius:8, marginBottom:10, fontSize:13, color:'#92400e' }}>⚠️ Email body empty hai</div>}

//           {/* ── OPTIONAL ATTACHMENTS ── */}
//           <div style={{ background:'#f9fafb', border:'1px solid #e5e7eb', borderRadius:10, padding:'14px 16px', marginBottom:16 }}>
//             <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:10 }}>
//               <div>
//                 <span style={{ fontWeight:600, fontSize:13, color:'#374151' }}>📎 Attachments</span>
//                 <span style={{ fontSize:11, color:'#94a3b8', marginLeft:8 }}>Optional — sirf tab add karo jab chahiye</span>
//               </div>
//               {attachments.length > 0 && (
//                 <button onClick={()=>{ setAttachments([]); setAttachPreviews([]) }}
//                   style={{ fontSize:11, color:'#dc2626', background:'none', border:'none', cursor:'pointer', padding:0 }}>
//                   Clear all
//                 </button>
//               )}
//             </div>
//             <AttachmentPanel />
//           </div>

//           {/* Progress bar */}
//           {(sending||done) && (
//             <div style={{ background:'#f9fafb', border:'1px solid #e5e7eb', borderRadius:10, padding:16, marginBottom:16 }}>
//               <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:8 }}>
//                 <span style={{ fontWeight:600 }}>{done?'✅ Complete!':'⏳ Sending...'}</span>
//                 <span style={{ color:'#6b7280' }}>{sent+failed} / {selectedCSV?.total}</span>
//               </div>
//               <div style={{ height:8, background:'#e5e7eb', borderRadius:100 }}>
//                 <div style={{ height:8, borderRadius:100, background:done?'#22c55e':'#3b82f6', width:`${progress}%`, transition:'width 0.3s' }} />
//               </div>
//               <div style={{ display:'flex', gap:16, marginTop:8, fontSize:12 }}>
//                 <span style={{ color:'#16a34a' }}>✓ {sent} sent</span>
//                 {failed>0 && <span style={{ color:'#ef4444' }}>✗ {failed} failed</span>}
//               </div>
//               {errors.length>0 && (
//                 <div style={{ marginTop:10, maxHeight:100, overflowY:'auto' }}>
//                   {errors.map((e,i)=><div key={i} style={{ fontSize:11, color:'#ef4444', fontFamily:'monospace' }}>✗ {e.email} — {e.error}</div>)}
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Action buttons */}
//           {!sending && !done && (
//             <div style={{ display:'flex', gap:10, alignItems:'center' }}>
//               <button onClick={()=>setTab('compose')} style={bSec}>← Edit</button>
//               <button onClick={handleSend}
//                 disabled={!selectedCSV||!subject.trim()||!body.trim()}
//                 style={{ ...bPri, opacity:(!selectedCSV||!subject.trim()||!body.trim())?0.4:1, cursor:(!selectedCSV||!subject.trim()||!body.trim())?'not-allowed':'pointer', fontSize:15, padding:'12px 32px' }}>
//                  Send to {selectedCSV?.total||0} Recipients
//               </button>
//             </div>
//           )}

//           {done && (
//             <button onClick={()=>{ setTab('csv'); setDone(false); setSent(0); setFailed(0); setProgress(0); setErrors([]) }}
//               style={bPri}>
//               ＋ New Campaign
//             </button>
//           )}
//         </div>
//       )}

//       {/* ══ HISTORY TAB ══ */}
//       {tab==='history' && (
//         <div style={{ display:'grid', gridTemplateColumns: selectedCampaign ? '340px 1fr' : '1fr', gap:16, alignItems:'start' }}>

//           {/* Left — campaign list */}
//           <div>
//             <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
//               <span style={{ fontWeight:700, fontSize:15 }}>Campaign History</span>
//               <button onClick={fetchCampaigns} style={bSec}>{campaignLoading?'...':'↻ Refresh'}</button>
//             </div>

//             {/* Filter pills */}
//             <div style={{ display:'flex', gap:6, marginBottom:12 }}>
//               {[['all','All'],['sent','✓ Sent'],['failed','✗ Failed']].map(([k,l])=>(
//                 <button key={k} onClick={()=>setCampaignFilter(k)}
//                   style={{ padding:'4px 12px', fontSize:12, borderRadius:20, cursor:'pointer', border:'1px solid #e5e7eb',
//                     background: campaignFilter===k ? '#111827' : 'white',
//                     color: campaignFilter===k ? 'white' : '#374151',
//                     fontWeight: campaignFilter===k ? 600 : 400 }}>
//                   {l}
//                 </button>
//               ))}
//             </div>

//             {campaignLoading
//               ? <p style={{ color:'#9ca3af', textAlign:'center', padding:'2rem' }}>Loading...</p>
//               : campaigns.length===0
//                 ? <div style={{ textAlign:'center', padding:'3rem 1rem', color:'#9ca3af' }}>
//                     <div style={{ fontSize:32, marginBottom:8 }} />
//                     <div>Koi campaign nahi abhi tak</div>
//                     <div style={{ fontSize:12, marginTop:4 }}>Send tab se email bhejo</div>
//                   </div>
//                 : campaigns
//                     .filter(c => {
//                       if (campaignFilter === 'sent')   return c.sentCount > 0
//                       if (campaignFilter === 'failed') return c.failedCount > 0
//                       return true
//                     })
//                     .map(c => {
//                       const isSelected = selectedCampaign === c._id
//                       const successRate = c.totalCount ? Math.round((c.sentCount/c.totalCount)*100) : 0
//                       const statusColor = c.status==='completed' ? '#16a34a' : c.status==='failed' ? '#dc2626' : '#d97706'
//                       return (
//                         <div
//                           key={c._id}
//                           role="button"
//                           tabIndex={0}
//                           onClick={()=>{ setSelectedCampaign(isSelected?null:c._id); if(!isSelected){ fetchCampaignDetail(c._id) } else { setCampaignDetail(null) } }}
//                           onKeyDown={e=>{ if(e.key==='Enter'||e.key===' '){ setSelectedCampaign(isSelected?null:c._id); if(!isSelected){ fetchCampaignDetail(c._id) } else { setCampaignDetail(null) } } }}
//                           style={{ border:`1px solid ${isSelected?'#93c5fd':'#e5e7eb'}`, borderRadius:10, padding:'12px 14px', marginBottom:8, cursor:'pointer',
//                             background: isSelected ? '#eff6ff' : 'white', transition:'all 0.15s' }}>
//                           <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 }}>
//                             <div style={{ fontWeight:600, fontSize:13, color:'#111827', flex:1, marginRight:8, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
//                               {c.subject}
//                             </div>
//                             <div style={{ display:'flex', gap:4, flexShrink:0 }}>
//                               <span style={{ fontSize:11, fontWeight:600, color:statusColor, background: `${statusColor}15`, padding:'2px 8px', borderRadius:10 }}>
//                                 {c.status}
//                               </span>
//                               <button onClick={e=>deleteCampaign(c._id,e)}
//                                 style={{ padding:'2px 7px', fontSize:11, background:'#fef2f2', color:'#dc2626', border:'1px solid #fecaca', borderRadius:5, cursor:'pointer' }}>
//                                 🗑
//                               </button>
//                             </div>
//                           </div>
//                           <div style={{ fontSize:11, color:'#6b7280', marginBottom:6 }}>
//                             {new Date(c.createdAt).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit'})}
//                             {c.csvName && <span style={{ marginLeft:8 }}>📄 {c.csvName}</span>}
//                           </div>
//                           {/* Mini stats bar */}
//                           <div style={{ display:'flex', gap:8, alignItems:'center' }}>
//                             <div style={{ flex:1, height:5, background:'#e5e7eb', borderRadius:10, overflow:'hidden' }}>
//                               <div style={{ height:5, background:'#22c55e', width:`${successRate}%`, borderRadius:10 }} />
//                             </div>
//                             <span style={{ fontSize:11, color:'#16a34a', fontWeight:600 }}>✓ {c.sentCount}</span>
//                             {c.failedCount > 0 && <span style={{ fontSize:11, color:'#ef4444', fontWeight:600 }}>✗ {c.failedCount}</span>}
//                             <span style={{ fontSize:11, color:'#9ca3af' }}>/ {c.totalCount}</span>
//                           </div>
//                         </div>
//                       )
//                     })
//             }
//           </div>

//           {/* Right — campaign detail */}
//           {selectedCampaign && (
//             <div style={{ border:'1px solid #e5e7eb', borderRadius:12, overflow:'hidden', background:'white' }}>
//               {detailLoading
//                 ? <div style={{ padding:'3rem', textAlign:'center', color:'#9ca3af' }}>Loading detail...</div>
//                 : campaignDetail && (
//                   <>
//                     {/* Detail header */}
//                     <div style={{ padding:'14px 16px', background:'white', borderBottom:'1px solid #e5e7eb' }}>
//                       <div style={{ fontWeight:700, fontSize:14, color:'#111827', marginBottom:4 }}>{campaignDetail.subject}</div>
//                       <div style={{ display:'flex', gap:16, fontSize:12, color:'#6b7280' }}>
//                         <span>Date : {new Date(campaignDetail.startedAt).toLocaleString('en-IN')}</span>
//                         {campaignDetail.csvName && <span>File Name : {campaignDetail.csvName}</span>}
//                       </div>
//                     </div>

//                     {/* Stats row */}
//                     <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', borderBottom:'1px solid white' }}>
//                       {[
//                         { label:'Total Sent', val:campaignDetail.sentCount,  color:'#16a34a', bg:'#f0fdf4' },
//                         { label:'Failed',     val:campaignDetail.failedCount, color:'#dc2626', bg:'#fef2f2' },
//                         { label:'Total',      val:campaignDetail.totalCount,  color:'#374151', bg:'#f9fafb' },
//                       ].map(s=>(
//                         <div key={s.label} style={{ padding:'14px 16px', background:s.bg, textAlign:'center' }}>
//                           <div style={{ fontSize:22, fontWeight:700, color:s.color }}>{s.val}</div>
//                           <div style={{ fontSize:11, color:'#6b7280', marginTop:2 }}>{s.label}</div>
//                         </div>
//                       ))}
//                     </div>

//                     {/* Results table */}
//                     {campaignDetail.results?.length > 0 && (
//                       <div style={{ maxHeight:420, overflowY:'auto' }}>
//                         <div style={{ padding:'8px 12px', borderBottom:'1px solid #f3f4f6', display:'flex', gap:6 }}>
//                           <span style={{ fontSize:11, color:'#6b7280', alignSelf:'center' }}>
//                             {campaignDetail.results.length} records
//                           </span>
//                         </div>
//                         <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
//                           <thead>
//                             <tr style={{ background:'#f9fafb', position:'sticky', top:0 }}>
//                               <th style={{ ...thS, padding:'8px 12px' }}>Status</th>
//                               <th style={{ ...thS, padding:'8px 12px' }}>Email</th>
//                               <th style={{ ...thS, padding:'8px 12px' }}>Name</th>
//                               <th style={{ ...thS, padding:'8px 12px' }}>Error</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {campaignDetail.results.map((r,i)=>(
//                               <tr key={i} style={{ borderTop:'1px solid #f3f4f6', background: r.status==='failed'?'#fff8f8':'white' }}>
//                                 <td style={{ padding:'7px 12px' }}>
//                                   <span style={{ fontSize:11, fontWeight:600, padding:'2px 7px', borderRadius:8,
//                                     background: r.status==='sent'?'#f0fdf4':'#fef2f2',
//                                     color: r.status==='sent'?'#16a34a':'#dc2626' }}>
//                                     {r.status==='sent' ? '✓ Sent' : '✗ Failed'}
//                                   </span>
//                                 </td>
//                                 <td style={{ padding:'7px 12px', fontFamily:'monospace', color:'#1d4ed8', fontSize:11 }}>{r.email}</td>
//                                 <td style={{ padding:'7px 12px', color:'#374151' }}>{r.name || '—'}</td>
//                                 <td style={{ padding:'7px 12px', color:'#ef4444', fontSize:11, maxWidth:180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}
//                                   title={r.error}>
//                                   {r.error || '—'}
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}
//                   </>
//                 )
//               }
//             </div>
//           )}
//         </div>
//       )}

//     </div>
//   )
// }

// // ─── Styles ───────────────────────────────────────────────────────
// const lS   = { display:'block', fontSize:12, fontWeight:600, color:'#6b7280', marginBottom:6 }
// const iS   = { width:'100%', padding:'10px 14px', fontSize:14, border:'1px solid #d1d5db', borderRadius:8, outline:'none', fontFamily:'inherit' }
// const bPri = { background:'#111827', color:'white', border:'none', borderRadius:8, padding:'10px 20px', fontWeight:600, fontSize:14, cursor:'pointer' }
// const bSec = { background:'white', color:'#374151', border:'1px solid #d1d5db', borderRadius:8, padding:'8px 16px', fontSize:13, cursor:'pointer' }
// const thS  = { padding:'10px 12px', textAlign:'left', fontSize:11, fontWeight:600, color:'#6b7280', textTransform:'uppercase' }
// const tdS  = { padding:'10px 12px' }

// export default BulkMailing



import React from 'react'

const BulkMailing = () => {
  return (
    <div>BulkMailing</div>
  )
}

export default BulkMailing